import { message } from 'antd';
import { patchWithCSRF } from './axiosWithCSRF';
import { envApiUrl } from './envApiUrl';

export const updateFile = async (data: any, refetch?: () => void) => {
  console.log('Updating file with: ', data);
  try {
    const response = await patchWithCSRF(`${envApiUrl}/files/`, data);
    message.success('Successfully updated file');
    refetch?.();
    return response.data;
  } catch (err: any) {
    console.error('updateFile error: ', err.response?.data?.message, err);
    message.error(err.response?.data?.message || 'Failed to update file');
  }
};
